var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.133,
    height: 37.812,
    viewBox: "0 0 42.133 37.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_51",
    x: 0,
    y: 0,
    width: 42.133,
    height: 37.812,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.561
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51-2",
    "data-name": "Trac\\xE9 51",
    d: "M470.519-92.435c.033-.146.068-.291.1-.438a5.15,5.15,0,0,1,5.187-4.183q11.274-.026,22.548,0a5.143,5.143,0,0,1,5.194,4.17,5.091,5.091,0,0,1,.1.995q.012,4.206,0,8.411a1.284,1.284,0,0,1-1.262,1.359,1.274,1.274,0,0,1-1.32-1.266c-.017-.647-.005-1.294-.005-1.941,0-2.07,0-4.14,0-6.26-.136.076-.246.132-.349.2q-5.367,3.335-10.733,6.672a5.112,5.112,0,0,1-4.815.5,6.567,6.567,0,0,1-1.03-.535q-5.343-3.312-10.679-6.637c-.1-.061-.2-.117-.337-.2-.005.116-.012.2-.012.277q0,7.117,0,14.234a2.565,2.565,0,0,0,1.986,2.644,3.332,3.332,0,0,0,.832.084q11.161.006,22.322,0a2.59,2.59,0,0,0,2.717-1.936,3.932,3.932,0,0,0,.1-.7,1.287,1.287,0,0,1,1.354-1.232A1.284,1.284,0,0,1,503.65-76.9a5.177,5.177,0,0,1-4.846,5.115q-.452.021-.905.022-10.967,0-21.933,0a5.341,5.341,0,0,1-3.387-1.059,5.1,5.1,0,0,1-2-3.357,1.726,1.726,0,0,0-.062-.214Zm3.693-1.548c.129.084.217.144.307.2q5.489,3.415,10.975,6.833a2.75,2.75,0,0,0,3.178,0q5.478-3.432,10.975-6.834c.1-.06.187-.127.3-.206a2.7,2.7,0,0,0-1.737-.487q-5.92,0-11.84,0H475.926A2.673,2.673,0,0,0,474.212-93.983Z",
    transform: "translate(-466.02 97.07)",
    fill: "#4fb1db"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5b5f8ac1f261f784b8eab55afbc3971e.svg";
export { ForwardRef as ReactComponent };